import React, { useState } from 'react';

export const GpxImporter = ({ onDataParsed, index = 0 }) => {
  const [error, setError] = useState(null);

  // ID único para que cada tarjeta de ruta active su propio input de archivo
  const fileInputId = `gpx-file-upload-${index}`;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const gpxText = event.target.result;
        const parser = new DOMParser();
        const xml = parser.parseFromString(gpxText, 'text/xml');
        
        const trkpts = Array.from(xml.querySelectorAll('trkpt'));
        
        if (trkpts.length === 0) {
          throw new Error('No se encontraron puntos de ruta (trkpt) en este archivo GPX.');
        }

        let totalElevationGain = 0;
        let totalElevationLoss = 0;
        const path = [];
        const SAMPLING_RATE = 3;

        trkpts.forEach((pt, idx) => {
          const lat = parseFloat(pt.getAttribute('lat'));
          const lon = parseFloat(pt.getAttribute('lon'));
          const eleEl = pt.querySelector('ele');
          const ele = eleEl ? parseFloat(eleEl.textContent) : null;

          // 1. Acumulado de desnivel (se evalúa en todos los puntos)
          if (idx > 0 && ele !== null) {
            const prevEleEl = trkpts[idx - 1].querySelector('ele');
            const prevEle = prevEleEl ? parseFloat(prevEleEl.textContent) : null;

            if (prevEle !== null) {
              const diff = ele - prevEle;
              if (diff > 0) {
                totalElevationGain += diff;
              } else {
                totalElevationLoss += Math.abs(diff);
              }
            }
          }

          // 2. Muestreo de coordenadas (1 de cada 3 + primero y último)
          if (idx === 0 || idx % SAMPLING_RATE === 0 || idx === trkpts.length - 1) {
            path.push([lat, lon]);
          }
        });

        const resultJson = {
          start: path[0],
          end: path[path.length - 1],
          path: path,
          elevation_gain: Math.round(totalElevationGain) || 0,
          elevation_loss: Math.round(totalElevationLoss) || 0,
          terrain: "Asfalto / Mixto",
          est_time: "0h 00min"
        };

        setError(null);
        onDataParsed(JSON.stringify(resultJson, null, 2));
      } catch (err) {
        console.error(err);
        setError(err.message || 'Error al procesar el archivo GPX.');
      }
    };

    reader.readAsText(file);
  };
  
  return (
    <div className="gpx-importer-container" style={{ margin: '10px 0' }}>
      <input
        type="file"
        accept=".gpx"
        id={fileInputId}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <label 
        htmlFor={fileInputId} 
        className="admin-route-upload-btn"
        style={{ 
          display: 'inline-block', 
          backgroundColor: '#00E676', 
          color: '#000', 
          fontWeight: 'bold',
          padding: '8px 12px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '12px'
        }}
      >
        🟢 Importar GPX (Ruta {index + 1})
      </label>
      {error && (
        <div style={{ color: '#ff4444', fontSize: '12px', marginTop: '5px' }}>
          ⚠️ {error}
        </div>
      )}
    </div>
  );
};